import {FaAward} from 'react-icons/fa'
import {TbBooks} from 'react-icons/tb'
import { MdOutlineDataObject } from "react-icons/md";
import { FaPersonChalkboard } from "react-icons/fa6";
import { BsFillPersonCheckFill } from "react-icons/bs";
import {BiHappyHeartEyes} from 'react-icons/bi'
import { CgRemote } from "react-icons/cg";



const data = [
    
    {
        id: 1, icon: < FaPersonChalkboard/>, title: 'Industry-Aligned Training', desc: "Programs designed around real UK job roles, tools, and workflows."
    },
    {
        id: 2, icon: <FaAward/>, title: 'Internship-Backed Certificates', desc: "Every program includes applied project work inspired by real client environments."
    },
    {
        id: 3, icon: <BsFillPersonCheckFill/>, title: 'Mentorship from UK Industry Professionals', desc: "Direct guidance from experts working in the UK tech ecosystem (FTSE 500, UK Universities)."
    },
    {
        id: 4, icon: <TbBooks/>, title: 'Career-Focused Learning', desc: "Built for employability, confidence, and practical readiness - not theory alone."
    },
    {
        id: 5, icon: <CgRemote/>, title: 'Flexible Learning Delivery', desc: "The programs are fully remote and designed with flexibility in mind."
    },
    {
        id: 6, icon: <BiHappyHeartEyes/>, title: 'Proven Participant Success ', desc: "Over 300 interns have successfully completed our programs, gaining practical experience, portfolio work, and industry-ready confidence."
    }
    
]


export default data